module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Prologue: Distressed Communities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART ONE")]), _vm._v(": A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GEIST")]), _vm._v(" Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EITGEIST")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("1. The Aging Church: A Future Katrina?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_vm._v("2. Is Society Prepared for Its Aging Population?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Confused Cultural Role of Seniors in Secular Society and the Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLICAL AND")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORICAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEMES OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GING")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Aging in a Biblical Context")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Biblical Roles for Seniors-Elders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Portrait of a Mature Christian Senior-Elder")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Elders as Exemplars and Mentors for Christian Renewal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Lived Wisdom of Christian Elders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Honoring Elders in Early Christianity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(": S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUTIONS FOR AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GING")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Primacy of Theological Anthropology in an Aging Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Aging Successfully: Myths and Realities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Caregiving: The Twenty-First Century’s Greatest Test of Character")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Local Senior Ministry Associations and Ecumenical Partnerships")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Important Steps to Unifying Our Communities")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(": L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGNIFICANT")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVING")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Faith Is All About Relationships in a Culture of Disability and Depression")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Facing Alzheimer’s Disease and Other Dementias with Hope in God’s Remembrance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Christians, Seniors and a More Personal Society")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Vital Role of Repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. In Summary: Becoming a Christian Elder in Rebuilding the Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")]), _vm._v(": F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISHING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELL")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Facing Death and Bereavement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Dying Elders, Living Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: “The Life Review” Preparation Tips and Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Church Survey Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Parent Care Readiness Program")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D: Sample Senior Ministry Association Correspondence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E: State Agencies on Aging")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("A Vision for the Aging Church")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0